import * as styles from "./Footer.module.less";
import { SubMenu } from "./SubMenu.tsx";

export function Footer({ currentPath }: { readonly currentPath: string }) {
  return (
    <footer className={styles.root}>
      <SubMenu currentPath={currentPath} />
    </footer>
  );
}
